













import gql from 'graphql-tag';
import Vue from 'vue';

interface User {
  id: string;
  name: string;
  country: string;
}

const query = gql`
  query {
    users: listUser(role: "cse", offset: 0, limit: 100) {
      id
      name
    }
  }
`;

export default Vue.extend({
  props: {
    value: Array as () => string[],
  },

  data() {
    return {
      users: [],
    };
  },

  apollo: {
    users: {
      query,
      fetchPolicy: 'cache-first',
    },
  },

  methods: {
    handleChange(val: string[]) {
      this.$emit('change', val);
    },
  },
});
